import {combineReducers} from "redux"
import cookies, * as fromCookies from "../../shared-components/store/localStorage/cookies/cookiesReducer"
import features, * as fromFeatures from "../../shared-components/store/localStorage/features/featuresReducer"
import sap from "./sapReducer"

/**
 * Part of the store to stock data which will be saved in local storage.
 * Ici, on ressort du cesuReducer cookies et features car ce sont des données partagées entre les sap et le cesu
 * On écrase pas non plus cesu qui doit être sauvegardé dans le localStorage de l'EBSap pour être réutilisable par l'EBCesu
 */
const localStorage = combineReducers({
    sap,
    cookies,
    features,
    cesu: (state = {}) => state,
})

export default localStorage

// COOKIES OPERATIONS
/**
 * Get cookies
 */
export const getCookiesChoices = state => fromCookies.getCookiesChoices(state.cookies)

// FEATURES OPERATIONS
/**
 * Get enabled features
 */
export const getEnabledFeatures = state => fromFeatures.getEnabledFeatures(state.features)
